/**
 * Anonymous usage counts: which parts of the site get used, never who uses them. Sends the tool
 * and an event name, nothing else. What's counted and why is in `apps/api/src/usage.ts`.
 */

import { API_URL } from "./config.ts";

/** Only the live site counts; dev runs and preview deploys would just be noise. */
const LIVE = location.hostname === "cte2-archives.pages.dev";
const sent = new Set<string>();

/** Counts `event` once per page load. Fire and forget: a count that fails must never show. */
export function countUsage(event: string): void {
  if (!LIVE || sent.has(event)) return;
  sent.add(event);
  fetch(`${API_URL}/usage?tool=archives&event=${event}`, { method: "POST", mode: "no-cors" }).catch(() => {});
}

/** `open` on every page load, and `day` once per browser per day, which reads as roughly people. */
export function countVisit(): void {
  countUsage("open");
  const today = new Date().toISOString().slice(0, 10);
  try {
    if (localStorage.getItem("usage-day") === today) return;
    localStorage.setItem("usage-day", today);
  } catch {
    return;
  }
  countUsage("day");
}
